import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-246116a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "refund-modal-title"
}, "批量发起退款确认", -1));
const _hoisted_2 = {
  class: "refund-header"
};
const _hoisted_3 = {
  class: "refund-header__col"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "订单总额", -1));
const _hoisted_5 = {
  class: "refund-header__amount"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__divider"
}, null, -1));
const _hoisted_7 = {
  class: "refund-header__col refund-header__col--right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "订单数", -1));
const _hoisted_9 = {
  class: "refund-header__amount"
};
const _hoisted_10 = {
  class: "refund-reason-label"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "refund-reason-label__text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "refund-reason-label__required"
}, "*"), /*#__PURE__*/_createTextVNode(" 退款原因 ")], -1));
const _hoisted_12 = {
  class: "refund-reason-label__tags"
};
const _hoisted_13 = {
  class: "screenshot-upload"
};
const _hoisted_14 = {
  key: 0,
  class: "screenshot-upload__loading"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "screenshot-upload__trigger"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "screenshot-upload__hint"
}, "支持 PNG, JPG 格式，最多 3 张，可直接 Ctrl+V 粘贴截图", -1));
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { awaitWrap, OK } from '@/common';
import { uploadAuditScreenshot } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'BatchRefundModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    records: null,
    submitLoading: {
      type: Boolean
    }
  },
  emits: ["update:modalVisible", "submit"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const refundReasons = ['未成年', '协商一致', '误操作'];
    const refundMode = ref('full');
    const refundRatio = ref();
    const refundReason = ref('');
    const refundScreenshots = ref([]);
    const ratioTouched = ref(false);
    const reasonTouched = ref(false);
    const screenshotTouched = ref(false);
    const uploadLoading = ref(false);
    const orderTotalAmount = computed(() => props.records.reduce((total, record) => total + Number(record.amount || 0), 0));
    const currencyText = computed(() => {
      var _props$records$;
      return ((_props$records$ = props.records[0]) === null || _props$records$ === void 0 ? void 0 : _props$records$.currency) || '¥';
    });
    const ratioValid = computed(() => {
      if (refundMode.value !== 'ratio') return true;
      const value = Number(refundRatio.value);
      return Number.isInteger(value) && value >= 1 && value <= 100;
    });
    const ratioError = computed(() => ratioTouched.value && !ratioValid.value);
    const reasonError = computed(() => reasonTouched.value && !refundReason.value.trim());
    const screenshotError = computed(() => screenshotTouched.value && !refundScreenshots.value.length);
    const toMoney = value => {
      const num = Number(value || 0);
      return Number.isNaN(num) ? '0.00' : num.toFixed(2);
    };
    const fillReason = reason => {
      refundReason.value = reason;
      reasonTouched.value = false;
    };
    const closeModal = () => {
      emit('update:modalVisible', false);
    };
    const resetForm = () => {
      refundMode.value = 'full';
      refundRatio.value = undefined;
      refundReason.value = '';
      refundScreenshots.value = [];
      ratioTouched.value = false;
      reasonTouched.value = false;
      screenshotTouched.value = false;
      uploadLoading.value = false;
    };
    const removeScreenshot = file => {
      refundScreenshots.value = refundScreenshots.value.filter(item => item.uid !== file.uid);
    };
    const uploadFile = async file => {
      var _props$records$2;
      if (!file.type.includes('image')) {
        message.error('请上传图片');
        return;
      }
      if (refundScreenshots.value.length >= 3 || uploadLoading.value) return;
      const uid = `${Date.now()}-${Math.random()}`;
      refundScreenshots.value.push({
        uid,
        status: 'uploading',
        url: ''
      });
      uploadLoading.value = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('businessId', ((_props$records$2 = props.records[0]) === null || _props$records$2 === void 0 ? void 0 : _props$records$2.orderNo) || 'BATCH_ORDER_REFUND');
      formData.append('businessType', 'ORDER_REFUND');
      formData.append('accessAttribute', '1');
      formData.append('desc', '');
      const [err, res] = await awaitWrap(uploadAuditScreenshot(formData));
      uploadLoading.value = false;
      if (err || (res === null || res === void 0 ? void 0 : res.code) !== OK) {
        refundScreenshots.value = refundScreenshots.value.filter(item => item.uid !== uid);
        message.error('上传图片失败');
        return;
      }
      const fileItem = refundScreenshots.value.find(item => item.uid === uid);
      if (fileItem) {
        var _res$data;
        fileItem.status = 'done';
        fileItem.url = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.fileUrl;
      }
      screenshotTouched.value = false;
    };
    const uploadScreenshot = async options => {
      await uploadFile(options.file);
    };
    const handleGlobalPaste = event => {
      var _event$clipboardData;
      if (!props.modalVisible || !((_event$clipboardData = event.clipboardData) !== null && _event$clipboardData !== void 0 && (_event$clipboardData = _event$clipboardData.files) !== null && _event$clipboardData !== void 0 && _event$clipboardData.length)) return;
      const file = event.clipboardData.files[0];
      uploadFile(file);
    };
    const handleOk = () => {
      if (!ratioValid.value) {
        ratioTouched.value = true;
        return;
      }
      if (!refundReason.value.trim()) {
        reasonTouched.value = true;
        return;
      }
      if (!refundScreenshots.value.length) {
        screenshotTouched.value = true;
        return;
      }
      const refundType = refundMode.value === 'ratio' ? 'RATIO' : 'FULL';
      const params = {
        refundType,
        refundReason: refundReason.value.trim(),
        customerComplaintUrl: refundScreenshots.value.map(item => item.url).join(',')
      };
      if (refundType === 'RATIO') {
        params.refundRatio = Number((Number(refundRatio.value) / 100).toFixed(4)).toString();
      }
      emit('submit', params);
    };
    watch(() => props.modalVisible, visible => {
      ratioTouched.value = false;
      reasonTouched.value = false;
      screenshotTouched.value = false;
      if (!visible) resetForm();
    });
    watch(refundMode, () => {
      ratioTouched.value = false;
      if (refundMode.value === 'full') refundRatio.value = undefined;
    });
    onMounted(() => document.addEventListener('paste', handleGlobalPaste));
    onBeforeUnmount(() => document.removeEventListener('paste', handleGlobalPaste));
    return (_ctx, _cache) => {
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        "confirm-loading": __props.submitLoading,
        "ok-text": "提交审批",
        "cancel-text": "取消",
        "ok-button-props": {
          danger: true
        },
        width: "560px",
        onOk: handleOk,
        onCancel: closeModal
      }, {
        title: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(currencyText)) + _toDisplayString(toMoney(_unref(orderTotalAmount))), 1)]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString(__props.records.length), 1)])]), _createVNode(_component_a_form, {
          layout: "vertical",
          class: "batch-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "统一退款金额",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_group, {
              value: refundMode.value,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => refundMode.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio, {
                value: "full"
              }, {
                default: _withCtx(() => [_createTextVNode("全额退款")]),
                _: 1
              }), _createVNode(_component_a_radio, {
                value: "ratio"
              }, {
                default: _withCtx(() => [_createTextVNode("按比例退款")]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), refundMode.value === 'ratio' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "退款比例",
            required: "",
            "validate-status": _unref(ratioError) ? 'error' : '',
            help: _unref(ratioError) ? '请输入 1-100 的正整数' : ''
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              value: refundRatio.value,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => refundRatio.value = $event),
              min: 1,
              max: 100,
              precision: 0,
              "addon-after": "%",
              placeholder: "请输入退款比例(例如50)",
              style: {
                "width": "100%"
              }
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["validate-status", "help"])) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            "validate-status": _unref(reasonError) ? 'error' : '',
            help: _unref(reasonError) ? '请输入退款原因' : ''
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(refundReasons, item => {
              return _createVNode(_component_a_tag, {
                key: item,
                onClick: $event => fillReason(item)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                _: 2
              }, 1032, ["onClick"]);
            }), 64))])]), _createVNode(_component_a_textarea, {
              value: refundReason.value,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => refundReason.value = $event),
              maxlength: 200,
              rows: 4,
              placeholder: "请输入退款原因，该原因将同步至微信支付平台..."
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["validate-status", "help"]), _createVNode(_component_a_form_item, {
            required: "",
            "validate-status": _unref(screenshotError) ? 'error' : '',
            help: _unref(screenshotError) ? '请至少上传一张客诉截图' : ''
          }, {
            label: _withCtx(() => [_createTextVNode("客诉截图")]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refundScreenshots.value, file => {
              return _openBlock(), _createElementBlock("div", {
                key: file.uid,
                class: "screenshot-upload__item"
              }, [file.status === 'uploading' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_unref(LoadingOutlined))])) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_createVNode(_component_a_image, {
                src: file.url,
                width: 72,
                height: 72,
                style: {
                  "object-fit": "cover"
                }
              }, null, 8, ["src"]), _createElementVNode("button", {
                class: "screenshot-upload__remove",
                type: "button",
                onClick: $event => removeScreenshot(file)
              }, "×", 8, _hoisted_15)], 64))]);
            }), 128)), refundScreenshots.value.length < 3 ? (_openBlock(), _createBlock(_component_a_upload, {
              key: 0,
              "custom-request": uploadScreenshot,
              "show-upload-list": false,
              accept: ".png,.jpg,.jpeg"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_unref(PlusOutlined)), _hoisted_17])]),
              _: 1
            })) : _createCommentVNode("", true)]), _hoisted_18]),
            _: 1
          }, 8, ["validate-status", "help"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});